const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Auto Indent',
  description: 'Auto Indent settings',
  sortOrder: 3,
  name: 'optimaAutoIndent',
  documentKey: 'optima_auto_indent',
  values: {
    combineType: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Optima Auto Indent',
      documentKey: 'optima_auto_indent',
    },
  },
};
